module.exports = "<div class=\"alert alert-danger hotel-not-found\" l10n>Sorry, hotel profile has been merged/unmerged or removed.</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/admin/admin-error404.html
// module id = 595
// module chunks = 0